<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P229F0001">
    <div class="form-row mt-3">
        <div class="form-field">
            <input pInputText type="text" formControlName="numero_linea" class="form-control" [placeholder]="'Ingrese número de línea'"
                [disabled]="model" appPermissionControl="P229K0001">
            <label>Número Línea</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="descripcion" class="form-control"
                [placeholder]="'Ingrese descripción'" appPermissionControl="P229K0002">
            <label>Descripción</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <p-dropdown 
                formControlName="tipo" 
                [options]="tipoOptions" 
                placeholder="Seleccione un tipo"
                optionLabel="label" 
                optionValue="value"
                appendTo="body" appPermissionControl="P229K0003">
            </p-dropdown>
            <label>Tipo</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading" appPermissionControl="P229B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P229B0002">
            <mat-icon>tune</mat-icon>
            Customizables
        </button>
    </div>
</form>